<template>
    <div>
        <el-form
                ref="form"
                :inline="true"
                :model="query"
                class="query-form"
                size="mini"
        >
            <el-form-item label="ASIN:" class="query-form-item">
                <el-input
                        v-model="query.asin"
                        placeholder="请输入ASIN"
                        style="width:160px"
                        clearable
                        @keyup.enter.native="searchForm"
                ></el-input>
            </el-form-item>
            <el-form-item label="国家：" class="query-form-item">
                <el-select
                        v-model="query.state"
                        ref="carrerSelect"
                        style="width: 100px;"
                        size="mini"
                        filterable
                        clearable
                        @change="getList"
                >
                    <el-option
                            v-for="item in us_arr"
                            :key="item.us"
                            :label="item.title"
                            :value="item.us"
                            :disabled="item.disabled"
                    >
                        <div class="keywords_arr_div">
                            <icon-svg
                                    :icon-class="item.us"
                                    style="font-size: 24px;margin-right:5px;"
                            ></icon-svg>
                            <span
                                    style="font-weight: 700; font-size: 14px;margin-left: 10px;"
                            >{{ item.title }}</span
                            >
                        </div>
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="备注:" class="query-form-item">
                <el-input
                        v-model="query.remark"
                        placeholder="请输入备注"
                        style="width:160px"
                        clearable
                ></el-input>
            </el-form-item>
            <el-form-item label="负责人:" class="query-form-item">
                <el-input
                        v-model="query.res_person"
                        placeholder="请输入负责人"
                        style="width:160px"
                        clearable
                ></el-input>
            </el-form-item>
            <el-form-item>
                <el-button icon="el-icon-refresh" @click="onReset"></el-button>
                <el-button
                        icon="el-icon-search"
                        type="primary"
                        @click="onSubmit"
                >查询
                </el-button
                >
            </el-form-item>
            <el-form-item>
                <el-button type="success" icon="el-icon-plus" @click="add"
                >添加ASIN
                </el-button
                >
                <el-button type="success" @click="onplural"
                >查看词根单复数
                </el-button
                >
                <el-button type="success" @click="nameList"
                >店铺名称列表
                </el-button
                >

                <el-input placeholder="请输入asin" v-model="openUrlAsin" style="width: 150px; margin-left: 10px">
                    <template slot="append">
                        <el-button type="success" @click="openUrlOnWindow">

                            <table-tooptip column-txt="打开"
                                           tool-tip-con="
                                     为什么只会打开一个窗口而不是多个?<br/>
                        浏览器默认对多标签弹窗做了阻截。<br/>
                        需要手动修改设置，打开浏览器设置-隐私和安全-网站设置-弹出式窗口和重定向<br/>
                        设置网站可以发送弹出式窗口并使用重定向|在允许发送弹出式窗口并使用重定向中添加网站链接"/>
                        </el-button>
                    </template>
                </el-input>
            </el-form-item>
        </el-form>
        <el-table
                v-loading="loading"
                :data="list"
                size="mini"
                ref="multipleTable"
                class="table_content etyme_index"
                :row-key="getRowKeys"
                :expand-row-keys="expands"
                @row-click="clickRowHandle"
                @expand-change="clickRowHandle1"
                border
                style="width: 100%;"
        >
            <el-table-column type="expand">
                <template slot-scope="props">
                    <inline
                            @getList="getList"
                            :ref="'inline' + props.row.asin"
                            :datasrow="props.row"
                    ></inline>
                </template>
            </el-table-column>
            <el-table-column label="图片" width="120" align="center">
                <template slot-scope="scope">
                    <div
                        style="width: 100px;height: 100px;"
                        slot="reference"
                    >
                        <img
                            style="width:100%;height:100%;"
                            :src="scope.row.asin_img"
                            alt
                        />
                    </div>
<!--                    <el-popover placement="right" title trigger="hover">-->
<!--                        <div style="width: 300px;height: 300px;">-->
<!--                            <img-->
<!--                                    style="width:100%;height:100%;"-->
<!--                                    :src="scope.row.asin_img"-->
<!--                                    alt-->
<!--                            />-->
<!--                        </div>-->
<!--                        <div-->
<!--                                style="width: 100px;height: 100px;"-->
<!--                                slot="reference"-->
<!--                        >-->
<!--                            <img-->
<!--                                    style="width:100%;height:100%;"-->
<!--                                    :src="scope.row.asin_img"-->
<!--                                    alt-->
<!--                            />-->
<!--                        </div>-->
<!--                    </el-popover>-->
                </template>
            </el-table-column>
            <el-table-column label="ASIN" width="150" align="center">
                <template slot-scope="scope">
                    <div style="padding: 20px 0">
                        <el-badge :value="scope.row.running_status == -1 ? '变狗' : '' " class="item">
                            <span>{{ scope.row.asin }}</span>
                            <icon-svg
                                :icon-class="scope.row.state"
                                style="font-size: 24px;margin-left:5px;"
                            ></icon-svg>

                            <div v-if="scope.row.asin != null" @click.stop="edirectToAsin(scope.row)"
                                 style="cursor: pointer;color: rgb(52, 73, 94);">
                                <i class="el-icon-s-promotion" style="margin-right:5px;"></i>{{ scope.row.url_asin }}
                            </div>
                        </el-badge>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="品牌" width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.asin_brand }}</div>
                </template>
            </el-table-column>
            <el-table-column label="标题" min-width="130" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.asin_title }}</div>
                </template>
            </el-table-column>
            <el-table-column label="负责人" width="120" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.res_person }}</div>
                </template>
            </el-table-column>
            <el-table-column label="备注" width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.remark }}</div>
                </template>
            </el-table-column>
            <el-table-column label="广告组合名称" width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.ad_portfolio_name }}</div>
                </template>
            </el-table-column>
            <el-table-column label="广告组合SP广告搜索词日期" width="180" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.early_date }}</div>
                    <div>{{ scope.row.late_date }}</div>
                </template>
            </el-table-column>
            <el-table-column label="基础信息更新时间" width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.keepa_update_time }}</div>
                </template>
            </el-table-column>

            <el-table-column label="操作" width="374">
                <template slot-scope="scope">
                    <div @click.stop>
                        <el-button
                                style="margin: 5px 0 5px 10px"
                                size="mini"
                                @click.native="onJump(scope.row, true)"
                        >跳转SP广告优化
                        </el-button
                        >
                        <el-button
                                style="margin: 5px 0 5px 10px"
                                size="mini"
                                @click.native="onSBJump(scope.row, true)"
                        >跳转SB广告优化
                        </el-button
                        >
                        <el-button type="primary"
                                   style="margin: 5px 0 5px 10px"
                                   size="mini"
                                   @click.native="keywordRanking(scope.row, true)"
                        >关键词排名
                        </el-button>

                        <el-button
                                style="margin: 5px 0 5px 10px"
                                type="success"
                                size="mini"
                                @click.native="sbvOpen(scope.row, false)"
                        >SB种子词库
                        </el-button>
                        <el-button
                                style="margin: 5px 0 5px 10px"
                                type="success"
                                size="mini"
                                @click.native="sbvOpen(scope.row, true)"
                        >SBV种子词库
                        </el-button>
                        <el-button
                                style="margin: 5px 0 5px 10px"
                                type="success"
                                size="mini"
                                @click.native="sdOpen(scope.row, true)"
                        >SD种子词库
                        </el-button>

                        <el-button
                                style="margin: 5px 0 5px 10px"
                                type="warning"
                                size="mini"
                                @click.native="recordOpen(scope.row)"
                        >排名掉出检测
                        </el-button
                        >
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-size="query.limit"
                :page-sizes="[20, 50, 100]"
                :total="query.total"
                background
                style="float: right;margin-top: 10px; margin-bottom: 5px"
                layout="total, sizes, prev, pager, next"
        >
        </el-pagination>
        <add
                :visible="ctrl.addDialogVisible"
                :title="'添加ASIN'"
                @close-callback="closeCllback"
        ></add>
        <upload
                :visible="ctrl.uploadDialogVisible"
                :formData="formData"
                :title="ctrl.dialogTitle"
                @close-callback="closeCllback"
        ></upload>
        <relevance
                ref="relevance"
                :visible="ctrl.relevanceDialogVisible"
                :formData="formData"
                :title="ctrl.dialogTitle"
                @close-callback="closeCllback"
        ></relevance>
        <upload1
                :visible="ctrl.upload1DialogVisible"
                :formData="formData"
                :title="ctrl.dialogTitle"
                @close-callback="closeCllback"
        ></upload1>
        <onremark
                :visible="ctrl.onremarkDialogVisible"
                :formData="formData"
                :title="ctrl.dialogTitle"
                @close-callback="closeCllback"
        ></onremark>
        <plural
                ref="plural"
                :visible="ctrl.pluralDialogVisible"
                :title="ctrl.dialogTitle"
                @close-callback="closeCllback"
        ></plural>
        <EditAdGroupName
                v-if="showAdGroup"
                :data="adGroupData"
                @close="closeAdGroupName"
                @onUpdate="onSubmit"
        />
        <RecordList
                title="列表记录"
                :formData="formData"
                v-if="ctrl.recordDialogVisible"
                :visible="ctrl.recordDialogVisible"
                @close-callback="closeCllback"
        />
        <sbvParseList
                :title="parse.title"
                :formData="formData"
                v-if="ctrl.sbvParseVisible"
                :visible="ctrl.sbvParseVisible"
                :type="parse.type"
                @close-callback="closeCllback"
        >
        </sbvParseList>
        <sdParseList
                title="SD广告组合解析列表"
                :formData="formData"
                v-if="ctrl.sdParseVisible"
                :visible="ctrl.sdParseVisible"
                @close-callback="closeCllback"
        >
        </sdParseList>
        <store-name-list :visible="this.ctrl.uploadFileListVisible" title="店铺名称列表"
                         @close-callback="closeCllback"></store-name-list>
        <keywordRanking :visible="this.ctrl.keywordRankingVisible" title="关键词排名"
                        @close-callback="closeCllback" :formData="formData"></keywordRanking>
        <child-info-modal :visible="ctrl.childInfoVisible" :info="childInfo" :closeFlag="true"
                          @close-callback="closeCllback"></child-info-modal>
    </div>
</template>

<script>
    import * as api from '@/api/Product/Product'
    import {link_us} from '@/utils/method'
    import Add from './add'
    import Inline from './inline'
    import Upload from './upload'
    import Upload1 from './upload1'
    import Onremark from './onremark'
    import Plural from './plural'
    import Onbutton from './onbutton'
    import Relevance from './relevance'
    import RecordList from './recordList'
    import sbvParseList from './sbvParseList'
    import sdParseList from './sdParseList'
    import EditAdGroupName from './components/editAdGroupName'
    import {binary_download} from '@/utils/method'
    import {downLoadFilePy} from '../../utils/method'
    import storeNameList from './storeNameList'
    import keywordRanking from './keywordRanking'
    import ChildInfoModal from './childInfoModal.vue'
    import tableTooptip from './tableTooptip.vue'

    export default {
        components: {
            Add,
            Upload,
            Inline,
            Onremark,
            Upload1,
            Plural,
            Relevance,
            Onbutton,
            EditAdGroupName,
            RecordList,
            sbvParseList,
            sdParseList,
            ChildInfoModal,
            keywordRanking,
            tableTooptip,
            storeNameList
        },
        data() {
            return {
                openUrlAsin: '',
                childInfo: {},
                parse: {
                    title: '',
                    type: ''
                },
                adGroupData: null,
                showAdGroup: false,
                ctrl: {
                    keywordRankingVisible: false,
                    addDialogVisible: false,
                    uploadFileListVisible: false,
                    onremarkDialogVisible: false,
                    pluralDialogVisible: false,
                    upload1DialogVisible: false,
                    relevanceDialogVisible: false,
                    uploadDialogVisible: false,
                    recordDialogVisible: false,
                    sbvParseVisible: false,
                    sdParseVisible: false,
                    childInfoVisible: false,
                },
                us_arr: [
                    {
                        us: 'US',
                        title: '美国'
                    },
                    {
                        us: 'UK',
                        title: '英国'
                    },
                    {
                        us: 'DE',
                        title: '德国'
                    }
                ],
                expands: [],
                formData: {},
                query: {
                    page: 1,
                    remark: '',
                    limit: 20
                },
                list: [],
                cList: [],
                disabled: false,
                loading: false
            }
        },
        created() {
            this.getList()
        },
        methods: {
            searchForm() {
                this.getList()
            },
            // 获取row的key值
            getRowKeys(row) {
                return row.asin
            },
            getList() {
                this.loading = true
                return api.seed_word_asin_list(this.query)
                    .then(res => {
                        if (res.code === 0) {
                            this.cList = res.data.list
                            this.cList.forEach((item, index) => {
                                this.cList[index].rankInfo = {
                                    rank_page_1: undefined,
                                    rank_page_2: undefined,
                                    rank_page_3: undefined
                                }
                                this.cList[index].rankChangeInfo = {
                                    rank_page_1_change: undefined,
                                    rank_page_2_change: undefined,
                                    rank_page_3_change: undefined
                                }

                                this.cList[index].adChangeInfo = {
                                    ad_rank_page_1_change: undefined,
                                    ad_rank_page_2_change: undefined,
                                    ad_rank_page_3_change: undefined
                                }
                                this.cList[index].adInfo = {
                                    ad_rank_page_1: undefined,
                                    ad_rank_page_2: undefined,
                                    ad_rank_page_3: undefined
                                }
                            })
                            this.query.total = res.data.total
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.message
                            })
                        }
                        this.list = this.cList
                        this.loading = false

                        // this.getPageTotal()
                    })
                    .catch(() => {
                        this.loading = false
                    })
            },
            getPageTotal() {
                for (const index in this.cList) {
                    api.seed_word_asin_get_three_page_total({id: this.cList[index].id}).then(res => {
                        if (res.code === 0) {
                            this.cList[index].rankInfo.rank_page_1 = res.data.rank_page_1
                            this.cList[index].rankInfo.rank_page_2 = res.data.rank_page_2
                            this.cList[index].rankInfo.rank_page_3 = res.data.rank_page_3
                            this.cList[index].adInfo.ad_rank_page_1 = res.data.ad_rank_page_1
                            this.cList[index].adInfo.ad_rank_page_2 = res.data.ad_rank_page_2
                            this.cList[index].adInfo.ad_rank_page_3 = res.data.ad_rank_page_3
                            this.cList[index].rankChangeInfo.rank_page_1_change = res.data.rank_page_1_change
                            this.cList[index].rankChangeInfo.rank_page_2_change = res.data.rank_page_2_change
                            this.cList[index].rankChangeInfo.rank_page_3_change = res.data.rank_page_3_change
                            this.cList[index].adChangeInfo.ad_rank_page_1_change = res.data.ad_rank_page_1_change
                            this.cList[index].adChangeInfo.ad_rank_page_2_change = res.data.ad_rank_page_2_change
                            this.cList[index].adChangeInfo.ad_rank_page_3_change = res.data.ad_rank_page_3_change

                            this.$set(this.list[index], 'rankInfo', {})
                            this.$set(this.list[index], 'adInfo', {})
                            this.$set(this.list[index], 'rankChangeInfo', {})
                            this.$set(this.list[index], 'adChangeInfo', {})

                            this.$set(this.list[index].rankInfo, 'rank_page_1', res.data.rank_page_1)
                            this.$set(this.list[index].rankInfo, 'rank_page_2', res.data.rank_page_2)
                            this.$set(this.list[index].rankInfo, 'rank_page_3', res.data.rank_page_3)
                            this.$set(this.list[index].adInfo, 'ad_rank_page_1', res.data.ad_rank_page_1)
                            this.$set(this.list[index].adInfo, 'ad_rank_page_2', res.data.ad_rank_page_2)
                            this.$set(this.list[index].adInfo, 'ad_rank_page_3', res.data.ad_rank_page_3)
                            this.$set(this.list[index].rankChangeInfo, 'rank_page_1_change', res.data.rank_page_1_change)
                            this.$set(this.list[index].rankChangeInfo, 'rank_page_2_change', res.data.rank_page_2_change)
                            this.$set(this.list[index].rankChangeInfo, 'rank_page_3_change', res.data.rank_page_3_change)
                            this.$set(this.list[index].adChangeInfo, 'ad_rank_page_1_change', res.data.ad_rank_page_1_change)
                            this.$set(this.list[index].adChangeInfo, 'ad_rank_page_2_change', res.data.ad_rank_page_2_change)
                            this.$set(this.list[index].adChangeInfo, 'ad_rank_page_3_change', res.data.ad_rank_page_3_change)

                            // console.log(this.cList[index].rankInfo)
                            // console.log(this.cList[index].adInfo)
                            // console.log(this.cList[index].rankChangeInfo)
                            // console.log(this.cList[index].adChangeInfo)
                            // console.log(res.data.rank_page_1)
                            // console.log(res.data.ad_rank_page_1)
                            // console.log(res.data.rank_page_1_change)
                            // console.log(res.data.ad_rank_page_1_change)
                            // console.log('---------')
                            this.$set(this.list, index, JSON.parse(JSON.stringify(this.cList[index])))
                            this.$forceUpdate()


                            // this.$nextTick(() => {
                            //
                            //     this.$delete(this.list[index].rankInfo, 'rank_page_1')
                            //     this.$delete(this.list[index].rankInfo, 'rank_page_2')
                            //     this.$delete(this.list[index].rankInfo, 'rank_page_3')
                            //     this.$delete(this.list[index].adInfo, 'ad_rank_page_1')
                            //     this.$delete(this.list[index].adInfo, 'ad_rank_page_2')
                            //     this.$delete(this.list[index].adInfo, 'ad_rank_page_3')
                            //     this.$delete(this.list[index].rankChangeInfo, 'rank_page_1_change')
                            //     this.$delete(this.list[index].rankChangeInfo, 'rank_page_2_change')
                            //     this.$delete(this.list[index].rankChangeInfo, 'rank_page_3_change')
                            //     this.$delete(this.list[index].adChangeInfo, 'ad_rank_page_1_change')
                            //     this.$delete(this.list[index].adChangeInfo, 'ad_rank_page_2_change')
                            //     this.$delete(this.list[index].adChangeInfo, 'ad_rank_page_3_change')
                            //
                            //
                            //     this.$set(this.list[index].rankInfo, 'rank_page_1', res.data.rank_page_1)
                            //     this.$set(this.list[index].rankInfo, 'rank_page_2', res.data.rank_page_2)
                            //     this.$set(this.list[index].rankInfo, 'rank_page_3', res.data.rank_page_3)
                            //     this.$set(this.list[index].adInfo, 'ad_rank_page_1', res.data.ad_rank_page_1)
                            //     this.$set(this.list[index].adInfo, 'ad_rank_page_2', res.data.ad_rank_page_2)
                            //     this.$set(this.list[index].adInfo, 'ad_rank_page_3', res.data.ad_rank_page_3)
                            //     this.$set(this.list[index].rankChangeInfo, 'rank_page_1_change', res.data.rank_page_1_change)
                            //     this.$set(this.list[index].rankChangeInfo, 'rank_page_2_change', res.data.rank_page_2_change)
                            //     this.$set(this.list[index].rankChangeInfo, 'rank_page_3_change', res.data.rank_page_3_change)
                            //     this.$set(this.list[index].adChangeInfo, 'ad_rank_page_1_change', res.data.ad_rank_page_1_change)
                            //     this.$set(this.list[index].adChangeInfo, 'ad_rank_page_2_change', res.data.ad_rank_page_2_change)
                            //     this.$set(this.list[index].adChangeInfo, 'ad_rank_page_3_change', res.data.ad_rank_page_3_change)
                            //
                            //     console.log(this.list[index])
                            //
                            //     // this.$set(this.list[index], 'rankInfo', {})
                            //     // this.$set(this.list[index], 'adInfo', {})
                            //     // this.$set(this.list[index], 'rankChangeInfo', {})
                            //     // this.$set(this.list[index], 'adChangeInfo', {})
                            //
                            //     // this.$set(this.cList[index], 'rankInfo', this.cList[index].rankInfo)
                            //     // this.$set(this.cList[index], 'adInfo', this.cList[index].adInfo)
                            //     // this.$set(this.cList[index], 'rankChangeInfo', this.cList[index].rankChangeInfo)
                            //     // this.$set(this.cList[index], 'adChangeInfo', this.cList[index].adChangeInfo)
                            //
                            //     // this.$set(this.cList[index], 'rankInfo', {})
                            //
                            //     // this.$set(this.list[index], 'rankInfo', this.cList[index].rankInfo)
                            //     // this.$set(this.list[index], 'adInfo',this.cList[index].adInfo)
                            //     // this.$set(this.list[index], 'rankChangeInfo', this.cList[index].rankChangeInfo)
                            //     // this.$set(this.list[index], 'adChangeInfo', this.cList[index].adChangeInfo)
                            //
                            //     // this.$set(this.list, index, JSON.parse(JSON.stringify(this.cList[index])))
                            //     // console.log('this.list', this.list)
                            //     this.$forceUpdate()
                            // })
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.message
                            })
                        }
                        this.$bus.$emit('auto_fit_state')
                    }).catch(() => {
                        this.loading = false
                    })
                }
            },
            downloadAssociatedAds(data) {
                if (!data.relevance_file_path) {
                    return this.$message({
                        type: 'error',
                        message: '无法下载！'
                    })
                }
                let obj = {
                    file_path: data.relevance_file_path
                }
                //下载
                binary_download(
                    '/apis/v1/common_file_export_by_path',
                    'post',
                    {},
                    obj,
                    'application/vnd.ms-excel',
                    `${data.asin} 下载关联广告组数据.xlsx`
                )
            },
            //修改关联关系
            onRelevance(data) {
                if (data.ad_portfolio_name_id !== 0) {
                    return
                }
                this.formData = JSON.parse(JSON.stringify(data))
                this.$refs.relevance.onList()
                this.$refs.relevance.onArr([...data.relevance_list])
                this.ctrl.relevanceDialogVisible = true
            },
            //更新
            ondetail(data) {
                this.loading = true
                api.update_asin_detail({
                    asin: data.asin,
                    state: data.state
                })
                    .then(res => {
                        this.loading = false
                        if (res.code === 0) {
                            this.getList()
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.message
                            })
                        }
                    })
                    .catch(() => {
                        this.loading = false
                    })
            },
            //跳转到内部竞价
            onJump(data, isNew = false) {
                // this.$router.push({
                //     path: "/adGroup/inside?asin=" + data.parent_asin
                // });
                this.$router.push({
                    path: `/statistics/index?asin=${data.asin}&state=${data.state}&isNew=${isNew}&ad_portfolio_name_id=${data.ad_portfolio_name_id}&id=${data.id}`
                    // query: data
                })
            },
            onSBJump(data, isNew = false) {
                // this.$router.push({
                //     path: "/adGroup/inside?asin=" + data.parent_asin
                // });
                console.log('====', data)
                this.$router.push({
                    path: `/statisticsSB/index?asin=${data.asin}&state=${data.state}&isNew=${isNew}&ad_portfolio_name_id=${data.id}&id=${data.id}`
                    // query: data
                })
            },
            keywordRanking(data) {
                this.formData = JSON.parse(JSON.stringify(data))
                this.ctrl.keywordRankingVisible = true
            },
            //上传自动否定无效词根
            onupload(data) {
                this.formData = data
                this.ctrl.dialogTitle = data.asin + ' 上传自动否定无效词根'
                this.ctrl.upload1DialogVisible = true
            },
            //查看词根单复数
            onplural() {
                this.ctrl.dialogTitle = '查看词根单复数'
                this.ctrl.pluralDialogVisible = true
                this.$refs.plural.onSubmit()
            },
            // 店铺名称列表
            nameList() {
                this.ctrl.uploadFileListVisible = true
            },
            //添加备注
            addremark(data, str) {
                if (str == '负责人') {
                    this.formData = {
                        res_person_value: data.res_person,
                        parent_asin: data.asin,
                        id: data.id
                    }
                } else {
                    this.formData = {
                        remark_value: data.remark,
                        parent_asin: data.asin,
                        id: data.id
                    }
                }
                this.ctrl.onremarkDialogVisible = true
                this.ctrl.dialogTitle = str
            },
            //打开记录
            recordOpen(data) {
                this.formData = {
                    parent_asin: data.asin,
                    state: data.state,
                    record_id: data.id,
                }
                this.ctrl.recordDialogVisible = true
            },
            sbvOpen(data, flag) {
                this.formData = {
                    ad_portfolio_name: data.ad_portfolio_name,
                    asin: data.asin,
                    state: data.state,
                }
                if (flag) {
                    this.parse.title = 'SBV广告组合解析列表'
                    this.parse.type = 'SBV'
                } else {
                    this.parse.title = 'SB广告组合解析列表'
                    this.parse.type = 'SB'
                }
                this.ctrl.sbvParseVisible = true
            },
            sdOpen(data, flag) {
                this.formData = {
                    ad_portfolio_name: data.ad_portfolio_name,
                    asin: data.asin,
                    state: data.state,
                }
                this.ctrl.sdParseVisible = true
            },
            //点击展开
            clickRowHandle(row, column) {
                if (column.label !== '') {
                    if (column.label == '备注') {
                        this.addremark(row, '备注')
                    }
                    if (column.label == '负责人') {
                        this.addremark(row, '负责人')
                    }
                    if (column.label == '广告组合名称') {
                        this.bindAdGroupName(row)
                    }
                    if (['标题'].includes(column.label)) {
                        this.childInfo = {
                            title: column.label,
                            info: row.asin_title,
                        }
                        this.ctrl.childInfoVisible = true
                    }
                    return
                }

                if (this.expands.includes(row.asin)) {
                    this.expands = this.expands.filter(
                        val => val !== row.asin
                    )
                } else {
                    this.expands.push(row.asin)
                    let str = 'inline' + row.asin
                    let that = this
                    setTimeout(function () {
                        that.$refs[str].handleClick()
                    }, 10)
                }
            },
            openUrlOnWindow() {
                if (this.openUrlAsin.trim() == '') {
                    this.$message.info('asin 不能为空')
                    return
                }
                const amazonLinks = ["https://www.amazon.com/dp/", "https://www.amazon.ca/dp/", "https://www.amazon.com.mx/dp/", "https://www.amazon.co.uk/dp/",
                    "https://www.amazon.de/dp/", "https://www.amazon.fr/dp/", "https://www.amazon.it/dp/", "https://www.amazon.es/dp/", "https://www.amazon.co.jp/dp/",];

                for (const item of amazonLinks) {
                    window.open(`${item}${this.openUrlAsin}`, '_blank')
                }
            },
            clickRowHandle1(row) {
                if (this.expands.includes(row.asin)) {
                    this.expands = this.expands.filter(
                        val => val !== row.asin
                    )
                } else {
                    this.expands.push(row.asin)
                    let str = 'inline' + row.asin
                    let that = this
                    setTimeout(function () {
                        that.$refs[str].handleClick()
                    }, 10)
                }
            },
            //添加文件夹
            add() {
                this.ctrl.addDialogVisible = true
            },
            //上传词根数据
            on_file_upload(data, str) {
                this.formData = JSON.parse(JSON.stringify(data))
                this.ctrl.uploadDialogVisible = true
                this.ctrl.dialogTitle = str
            },
            //分页
            handleCurrentChange(val) {
                this.query.page = val
                this.getList()
            },
            handleSizeChange(val) {
                this.query.limit = val
                this.getList()
            },
            //重置
            onReset() {
                this.query.page = 1
                this.query.limit = 20
                this.query.asin = ''
                this.getList()
            },
            //查询
            onSubmit() {
                this.query.page = 1
                this.query.limit = 20
                this.getList()
            },
            // 关闭弹窗回调
            closeCllback(isshow) {
                this.ctrl.keywordRankingVisible = false
                this.ctrl.uploadFileListVisible = false
                this.ctrl.addDialogVisible = false
                this.ctrl.uploadDialogVisible = false
                this.ctrl.onremarkDialogVisible = false
                this.ctrl.upload1DialogVisible = false
                this.ctrl.pluralDialogVisible = false
                this.ctrl.pluralDialogVisible = false
                this.ctrl.relevanceDialogVisible = false
                this.ctrl.recordDialogVisible = false
                this.ctrl.sbvParseVisible = false
                this.ctrl.sdParseVisible = false
                this.ctrl.childInfoVisible = false
                if (isshow) return
                this.getList()
            },
            bindAdGroupName(adGroupData) {
                this.showAdGroup = true
                this.adGroupData = adGroupData
            },
            closeAdGroupName() {
                this.showAdGroup = false
            },
            downFile(path) {
                if (!path) {
                    return this.$message({
                        type: 'error',
                        message: '无法下载！'
                    })
                }
                downLoadFilePy(path, '种子词数据')
            },
            //跳转到亚马逊产品页面
            edirectToAsin(data) {
                // let url =
                //     link_us(data.state) +
                //     'dp/' +
                //     data.url_asin_href +
                //     '?th=1&psc=1'
                window.open(data.url_asin_href, '_blank')
            },
        }
    }
</script>

<style type="text/scss" lang="scss" scoped>
    .ceil-span {
        margin: 0 5px;
        width: 40px;
        float: left;
    }

    // .ceil-color {
    //   color: #ff0000;
    // }
    .ceil-color_green {
        color: #00e640;
    }

    .ceil-color_red {
        color: #ff0000;
    }

    /deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
        background-color: #fff !important;
    }

    /deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
        cursor: pointer;
        // background-color: rgb(221, 233, 255) !important;
        background-color: #fff !important;
    }

    /deep/ .el-button--mini {
        padding: 5px 5px !important;
    }

    /deep/ .el-table__expanded-cell[class*="cell"] {
        padding: 0 !important;
    }

    .pen:hover {
        cursor: pointer;
        text-decoration: underline;
    }

    .table_content {
        height: calc(100vh - 190px);
        overflow: auto;
        border: 1px solid #ebeef5;
    }

    /deep/ .el-table::before {
        display: none;
    }
</style>
